module.exports = __webpack_public_path__ + "static/img/59.c2089a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/59.jpg
// module id = x9ck
// module chunks = 1